require('../../favorites/favoritesService');
require('../../shared/singleGameService');
require('../../shared/singleClipService');

"use strict";

angular.module('app.currentUser.clearSessionService', [
    'app.favorites.favoritesService',
    'app.shared.singleGameService',
    'app.shared.singleClipService'
])
    .factory('app.currentUser.clearSessionService', [
        'app.favorites.favoritesService',
        'app.shared.singleGameService',
        'app.shared.singleClipService',
        function (favorites,
                  singleGame,
                  singleClip) {
            return function () {
                favorites.clear();
                singleGame.clear();
                singleClip.clear();
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/currentUser/clearSessionService.js